import * as AnalyticsApi from '@/api/analytics';
import { RAW_EVENT_NAMES } from '@/constants/analytics';

/**
 * @param {string | undefined | null} userId
 * @param {string} objectId unique id for content and widget or link name for social buttons
 * @param {LINK_CLICK_TYPES} objectType one of LINK_CLICK_TYPES
 */
async function sendLinkClickEvent(userId, params) {
  const { objectId, objectType } = params;

  if (!userId || !objectId || !objectType) {
    return;
  }

  await AnalyticsApi.pushEvent(userId, RAW_EVENT_NAMES.LINK_CLICK, {
    objectId,
    objectType,
  });
}

export default sendLinkClickEvent;
